// Aftergrow sticky bar. Link mode (the homepage): below 750 px, after about 40 % of the page.
// Buy mode (the product page): at every width, once the main offer button is above the screen.
// Both hide while the chosen elements (the offer, the final call to action, the footer) are on
// screen. No animation: it appears or not. Below 990 px the document itself scrolls.
(() => {
  const bar = document.querySelector('[data-ag-sticky]');
  if (!bar) return;

  const buy = bar.dataset.mode === 'buy';
  const phone = window.matchMedia('(max-width: 749px)');
  const showAfter = (parseFloat(bar.dataset.showAfter) || 40) / 100;
  const main = buy ? document.querySelector('[data-ag-offer] [data-ag-offer-button]') : null;
  const onScreen = new Set();
  let passed = false;
  let queued = false;

  const progress = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    return max > 0 ? window.scrollY / max : 0;
  };

  const update = () => {
    queued = false;
    const show = onScreen.size === 0 && (buy ? passed : phone.matches && progress() >= showAfter);
    bar.hidden = !show;
    document.documentElement.classList.toggle('ag-sticky-on', show);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === main) passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      else if (entry.isIntersecting) onScreen.add(entry.target);
      else onScreen.delete(entry.target);
    });
    update();
  });

  if (main) observer.observe(main);
  (bar.dataset.hideOver || '').split(',').forEach((selector) => {
    const clean = selector.trim();
    if (!clean) return;
    try {
      document.querySelectorAll(clean).forEach((el) => observer.observe(el));
    } catch (error) {
      // An invalid selector in the section setting is skipped.
    }
  });

  if (!buy) {
    window.addEventListener('scroll', () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    phone.addEventListener('change', update);
  }
  update();
})();
